import { useTranslator } from "@eo-locale/react";
import { useEffect, useState } from "react";

import {
  Box,
  Input,
  SearchIcon,
  InputGroup,
  InputRightElement
} from "@/storybook-components";
import { setCurrentPage, updateFinder } from "@/redux/features/projects/slice";
import { useAppDispatch, useAppSelector } from "@/redux/store/hooks";

const SearchFilter = (): JSX.Element => {
  const { translate } = useTranslator();
  const dispatch = useAppDispatch();
  const { finder } = useAppSelector((state) => state.projects);
  const { queryFilter } = useAppSelector((state) => state.projectFinder);
  const { locales } = queryFilter;

  const [searchedText, setSearchedText] = useState("");

  useEffect((): void => {
    setSearchedText(finder.name);
  }, [finder]);

  const handleChange = (value) => {
    dispatch(updateFinder({ name: value }));
    dispatch(setCurrentPage(1));
  };

  return (
    <Box
      w={["100%", "100%", "40%", "40%"]}
      p={2}
      className="ehq-projectsSearchFilterContainer"
    >
      <InputGroup>
        <Input
          pr="40px"
          overflow="hidden"
          value={searchedText}
          aria-label={translate("projectFinder.search.placeholder")}
          placeholder={
            locales["projects.search.placeholder"] ||
            translate("projectFinder.search.placeholder")
          }
          onChange={(e) => handleChange(e.target.value)}
          data-tname="projects-menu-top-search-input"
          className="ehq-projectsSearchFilter"
        />
        <InputRightElement>
          <SearchIcon />
        </InputRightElement>
      </InputGroup>
    </Box>
  );
};

export default SearchFilter;
